import Actions from '../../odata/actions';

const actions = new Actions('medicalDevice', 'medicalDevices');

export default actions;
